export default (o) => !o;
